'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progress = require('./progress');

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _progress2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/progress/index.js
// module id = 1123
// module chunks = 0